
<template>

    <v-card>
        <v-card-title>User inputs (DemoComponentCard)</v-card-title>
        <v-card-text class="green">
                        <p>This shows how to pass reactive data to a child component (DemoComponentCard)</p>
            </v-card-text>
        <v-container>
          <VDataTable
            :headers="headers"
            :items="inputs"
            :items-per-page="10"
          >
          </VDataTable>
        </v-container>
    </v-card>



</template>
<style >

</style>
<script>



import {  ref } from 'vue';

import { VDataTable } from "vuetify/components";

export default {
props: {
    inputs: {type: Array, default: () => []}
},
emits: [],
setup( props, {emit}) {



    const headers = ref([
        { align: 'left', title: 'time', key: 'time', sortable: false },
        { align: 'left', title: 'input', key: 'input', sortable: false },
    ]);

    return {
        headers
    };
},
components: {VDataTable  }
}
</script>
